import { type DatasetName, type ModuleId } from '../../types';

/**
 * Hardcoded mapping of each data source to the modules it impacts.
 * Used until the BE builds a dedicated data-health service.
 */
export const DATA_SOURCE_TO_MODULES_IMPACTED_MAP: Record<
  DatasetName,
  ModuleId[]
> = {
  sales: ['BUY', 'RBL', 'RBL-NEW', 'RO', 'REPLEN'],
  inventory: ['BUY', 'RBL', 'RBL-NEW', 'RO', 'REPLEN'],
  warehouse: ['BUY', 'RBL', 'RBL-NEW', 'RO', 'REPLEN'],
  production: ['RO', 'REPLEN'],
  forecast: ['BUY', 'RBL', 'RBL-NEW', 'RO', 'REPLEN'],
  solver_run: ['RBL-NEW'],
};
